import { useEffect } from 'react'
import Header from '../components/site/Header'
import ParallaxHero from '../components/site/ParallaxHero'
import AboutSection from '../components/site/AboutSection'
import CtaBand from '../components/site/CtaBand'
import ConceptSection from '../components/site/ConceptSection'
import ServicesSection from '../components/site/ServicesSection'
import ProcessSection from '../components/site/ProcessSection'
import CollaborationsSection from '../components/site/CollaborationsSection'
import ReviewsSection from '../components/site/ReviewsSection'
import FinalCtaSection from '../components/site/FinalCtaSection'
import Footer from '../components/site/Footer'
import StickyCta from '../components/site/StickyCta'
import useSEO from '../hooks/useSEO'
import usePrerenderReady from '../hooks/usePrerenderReady'

export default function HomePage() {
  useSEO({
    title:
      'Francesca Zaccari — Travel Designer e Accompagnatrice Turistica | Fra un viaggio e l\u2019altro',
    description:
      'Itinerari su misura che uniscono viaggio, arte e cultura. Travel designer e accompagnatrice turistica certificata: viaggi culturali e d\u2019arte in Italia e all\u2019estero. Prenota la consulenza gratuita di 15 minuti.',
    keywords:
      'Francesca Zaccari, travel designer, accompagnatrice turistica, viaggi culturali arte Italia, itinerari personalizzati, travel designer Italia',
    ogImage: 'https://cb-c16daa2b.coderblock.dev/images/opengraph.jpg',
  })
  usePrerenderReady()

  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname)
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
      // Il browser può rieseguire il salto all'ancora dopo il primo frame: lo annulliamo
      const frame = window.requestAnimationFrame(() => window.scrollTo({ top: 0 }))
      return () => window.cancelAnimationFrame(frame)
    }
  }, [])

  return (
    <div className="bg-cream text-ink">
      <Header />
      <main>
        <ParallaxHero />
        <AboutSection />
        <CtaBand />
        <ConceptSection />
        <ServicesSection />
        <ProcessSection />
        <CollaborationsSection />
        <ReviewsSection />
        <FinalCtaSection />
      </main>
      <Footer />
      <StickyCta />
    </div>
  )
}
